import React, { useEffect } from 'react';
import {
  Switch,
  Route,
  useLocation
} from 'react-router-dom';

import './css/style.scss';

import AOS from 'aos';
import { focusHandling } from 'cruip-js-toolkit';

import Home from './pages/Home';
import Privacy from './pages/Privacy';
import Returns from './pages/Returns';
import Terms from './pages/TermsAndCon';
import Cookies from './pages/Cookies';
import Disclaimer from './pages/Disclaimer';

function App() {

  const location = useLocation();

  useEffect(() => {
    AOS.init({
      once: true,
      disable: 'phone',
      duration: 700,
      easing: 'ease-out-cubic',
    });
  });

  useEffect(() => {
    document.querySelector('html').style.scrollBehavior = 'auto'
    window.scroll({ top: 0 })
    document.querySelector('html').style.scrollBehavior = ''
    focusHandling('outline');
  }, [location.pathname]); // triggered on route change

  return (
    <>
      <Switch>
        <Route exact path="/">
          <Home />
        </Route>
        <Route path="/privacy">
          <Privacy />
        </Route>
        <Route path="/returns">
          <Returns />
        </Route>
        <Route path="/terms">
          <Terms />
        </Route>
        <Route path="/cookies">
          <Cookies />
        </Route>
        <Route path="/disclaimer">
          <Disclaimer />
        </Route>
      </Switch>
    </>
  );
}

export default App;
